module.exports = __webpack_public_path__ + "static/img/background.75fe6e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Login/background.png
// module id = VKpl
// module chunks = 151